import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.scrollFunc();
    }

    scrollFunc() {
        const elements = [...document.querySelectorAll(".js-scrolltext")];

        elements.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 60%",
                end: "bottom+=200px 60%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");
                },
                onUpdate: (self) => {
                    if (el.getAttribute("data-color")) {
                        el.style.backgroundImage = `linear-gradient(100deg, rgb(197, 0, 70) ${self.progress * 100}%, rgb(255, 255, 255,1) ${
                            (self.progress + 0.3) * 100
                        }%,rgb(255, 255, 255,0.1) 0%)`;
                    }
                },
                once: true,
            });
        });

        const bg = document.querySelector(".js-scrollbg");

        ScrollTrigger.create({
            trigger: bg,
            start: "top 0%",
            onUpdate: (self) => {
                bg.style.transform = `translate(-50%,${self.progress * 200}px)`;
            },
        });
    }
}
